module.exports = __webpack_public_path__ + "static/media/31.052e6171.png";